var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillNoAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#F6F7FA",
    stroke: "#DFE2EB",
    strokeWidth: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9276 10H22.1341C22.6123 10 23 10.3877 23 10.8659V18.0123C23 19.7044 22.5639 21.3681 21.7338 22.8426C21.7224 22.8629 21.6984 22.8724 21.6763 22.8655L19.8371 22.2915L17.2235 24.8805C17.1567 24.9467 17.049 24.9467 16.9822 24.8805L14.3686 22.2915L12.3329 23.0633C12.306 23.0734 12.2758 23.0619 12.2626 23.0363C11.4329 21.4311 11 19.6504 11 17.8435V10.9276C11 10.4153 11.4153 10 11.9276 10Z",
    stroke: "#525D71",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16H19",
    stroke: "#525D71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18L17 14",
    stroke: "#525D71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillNoAttachment);
export default __webpack_public_path__ + "static/media/bill-no-attachment.a7a557c7b856da53f4e3fb973d7e309e.svg";
export { ForwardRef as ReactComponent };